import { Crunchbase, Global, Linkedin, Twitter } from '@clearkit/icons';
import { CKLayoutHorizontal } from 'clearkit';

import { TokenGroup, TokenLink } from '~/components/ListItem/Tokens';

import { TargetMarketsCompany } from '../types';

export const CompanyLinks = ({
  company,
}: {
  company: TargetMarketsCompany;
}) => {
  const { domain, linkedin, twitter, crunchbase } = company;

  return (
    <CKLayoutHorizontal
      alignItems="center"
      className="h-3 divide-x divide-gray-200 basis-auto shrink-0 grow min-h-[1.5rem]"
      gap="0.75rem"
      justifyContent="start"
    >
      <TokenGroup>
        <TokenLink
          hasToken={!!domain}
          href={`https://${domain}`}
          target="_blank"
        >
          <Global />
        </TokenLink>
        <TokenLink
          hasToken={!!linkedin}
          href={`https://linkedin.com/${linkedin}`}
          target="_blank"
        >
          <Linkedin />
        </TokenLink>
        <TokenLink
          hasToken={!!twitter}
          href={`https://twitter.com/${twitter}`}
          target="_blank"
        >
          <Twitter />
        </TokenLink>
        <TokenLink
          hasToken={!!crunchbase}
          href={`https://crunchbase.com/${crunchbase}`}
          target="_blank"
        >
          <Crunchbase />
        </TokenLink>
      </TokenGroup>
    </CKLayoutHorizontal>
  );
};
